var map = {
	"./backarrow.png": 36135,
	"./bankname_sample0.png": 70413,
	"./bankname_sample1.png": 46172,
	"./currency_icon.png": 28555,
	"./deposit_btn.png": 70532,
	"./disable-login.png": 54478,
	"./error-icon.png": 43203,
	"./gamehistory_icon.png": 86297,
	"./instapay_btn.png": 94746,
	"./logout_icon.png": 77945,
	"./namechange_icon.png": 90381,
	"./profile_icon00.png": 88121,
	"./profile_icon01.png": 57805,
	"./profile_icon02.png": 72363,
	"./profile_icon03.png": 38321,
	"./profile_icon04.png": 66039,
	"./profile_icon05.png": 45857,
	"./profile_icon06.png": 42234,
	"./profile_icon07.png": 41754,
	"./profile_icon08.png": 38229,
	"./profilechange_icon.png": 5120,
	"./referral_icon.png": 68219,
	"./security_icon.png": 4487,
	"./sizearrow.png": 64309,
	"./transactions_icon.png": 99902,
	"./vipclass_0.png": 70352,
	"./vipclass_1.png": 51543,
	"./vipclub_icon.png": 34631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12234;